






















import { State, Getter, Mutation, Action } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
    Data,
    Filter,
    FacetFilter,
    FacetQuery,
    FilterQuery,
    SearchFilter
} from '@/models/dynamiclist';
import { each } from 'lodash';

@Component({})
export default class FacetFilterComponent extends Vue {

    public get active(): boolean {
        return this.isActive(this.filter.id);
    }

    public get inactive(): boolean {
        return this.isInactive(this.filter.id);
    }

    public get query(): FacetQuery {
        return this.filterQuery(this.filter.id) as FacetQuery;
    }

    @Prop({ required: true })
    public filter!: FacetFilter;

    @Action('toggleFacet')
    public toggleFacet!: (cmd: { filterId: string, facetId: string}) => void;

    @Action('fetchResultsDebounced')
    public fetchResultsDebounced!: () => void;

    @Getter('filterIsActive')
    private isActive!: (filterId: string) => boolean;

    @Getter('filterIsInactive')
    private isInactive!: (filterId: string) => boolean;

    @Getter('filterQuery')
    private filterQuery!: (filterId: string) => FilterQuery<any>;

    @Mutation('setActive')
    private setActive!: (filterId: string) => void;

    @Mutation('setFilterQuery')
    private setFilterQuery!: (cmd: { filterId: string, filterQuery: FilterQuery<any> }) => void;

    @Mutation('setFilterQueryValue')
    private setFilterQueryValue!: (cmd: { filterId: string, value: any }) => void;

    public filterValueActive(filterValueId: string): boolean {
      if (this.query !== undefined && this.query.value !== undefined) {
        return this.query.value.indexOf(filterValueId) !== -1;
      }

      return false;
    }

    public mounted() {
        const defaultValues = this.filterQuery(this.filter.id) as FacetQuery;

        this.setFilterQuery({
          filterId: this.filter.id,
          filterQuery:
            {
              filterTemplateId: this.filter.templateId,
              value: []
            } as FacetQuery
        });

        if (defaultValues && defaultValues.value) {
            const fqString = (defaultValues.value as unknown) as string;
            const ids = JSON.parse(fqString) as string[];
            if (ids) {
              ids.forEach((id) => {
                this.toggleFacet({ filterId: this.filter.id, facetId: id });
              });
            }
        }
    }

    public getLabelText(id: string): string {
        const lang = document.documentElement.lang;
        let text = '';
        if (lang.indexOf('da') > -1) {
            text = this.filterValueActive(id) ? 'Fravælg' : 'Vælg';
        } else {
            text = this.filterValueActive(id) ? 'Deselect' : 'Select';
        }
        return text;
    }

    public deselectFilter(): void {
        this.toggleActive(false);
    }

    public toggle(facetId: string): void {
        this.toggleFacet({filterId: this.filter.id, facetId });
        this.fetchResultsDebounced();
    }

    public toggleActive(value?: boolean): void {
        if (value !== undefined) {
            if (value) {
                this.setActive(this.filter.id);
            } else {
                this.setActive('');
            }
        } else {
            if (this.isActive(this.filter.id)) {
                this.setActive('');
            } else {
                this.setActive(this.filter.id);
            }
        }

    }
}

